import React, { useState } from "react";
import { Button } from "@mui/material";
import {
  Controller,
  FormProvider,
  useFieldArray,
  useForm,
} from "react-hook-form";
import { Checkbox, DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";

const GetName = (name) => {
  return name?.replace(/ /g, "");
};

const FloorRatesModal = (props) => {
  const { onSubmit, isChecked, setIsChecked, isModalOpen, formValues } = props;
  const methods = useForm({
    defaultValues: formValues,
  });
  const {
    control,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
  } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "products",
  });
  console.log("NORMAL FORM", isChecked)

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {fields?.map((item, index) => (
          <section className="flooring_new_rate_card">
            <div className="rate_card_head">
              <h4>{item.name}</h4>
              <div className="input-group">
                <span className="checkbox">
                  <Controller
                    control={control}
                    name={`products.[${index}].active`}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => {
                      return (
                        <>
                          <Checkbox
                            onChange={(e) => {
                              field.onChange(e.target.checked ? 0 : 1);
                              setIsChecked({
                                ...isChecked,
                                [GetName(item.name)]: e.target.checked,
                              });
                            }}
                            checked={field.value == 0 ? true : false}
                          />
                          Disable Flooring Rate
                        </>
                      );
                    }}
                  />
                </span>
              </div>
            </div>
            <div
              style={{
                pointerEvents: isChecked[GetName(item.name)] ? "none" : "auto",
              }}
            >
              <div className="rate_card_input_group">
                <div className="rate_card_input_info">
                  <p>Flooring Int. (30 days)</p>
                  <div className="rate_card_input_block">
                    <Controller
                      control={control}
                      name={`products.[${index}].interest_from`}
                      rules={{
                        required: !isChecked[GetName(item.name)],
                      }}
                      render={({ field }) => {
                        return (
                          <div className="input-group">
                            <label>From</label>
                            <InputNumber
                              type="number"
                              min={0}
                              disabled={watch(`products.[${index}].active`) == 0}

                              status={
                                isChecked[GetName(item.name)]
                                  ? null
                                  : errors?.products?.[index]?.interest_from
                                    ? "error"
                                    : null
                              }
                              prefix="%"
                              name={field.name}
                              ref={field.ref}
                              value={field.value}
                              placeholder="0"
                              precision={2}
                              step="0.01"
                              className="!w-full cusAdmInputNumber2 percentage_right arrHid"
                              onChange={(val) => field.onChange(val)}
                            />
                          </div>
                        );
                      }}
                    />
                    <Controller
                      control={control}
                      name={`products.[${index}].interest_to`}
                      rules={{
                        required: !isChecked[GetName(item.name)],
                      }}
                      render={({ field }) => {
                        return (
                          <div className="input-group">
                            <label>To</label>
                            <InputNumber
                              type="number"
                              min={0}
                              disabled={watch(`products.[${index}].active`) == 0}

                              status={
                                isChecked[GetName(item.name)]
                                  ? null
                                  : errors?.products?.[index]?.interest_to
                                    ? "error"
                                    : Number(
                                      getValues(
                                        `products.[${index}].interest_from`
                                      )
                                    ) > field.value
                                      ? "error"
                                      : null
                              }
                              prefix="%"
                              name={field.name}
                              ref={field.ref}
                              value={field.value}
                              placeholder="0"
                              precision={2}
                              step="0.01"
                              className="!w-full cusAdmInputNumber2 percentage_right arrHid"
                              onChange={(val) => field.onChange(val)}
                            />
                            {watch(`products.[${index}].interest_to`) !== "" &&
                              Number(
                                watch(`products.[${index}].interest_from`)
                              ) >
                              Number(
                                watch(`products.[${index}].interest_to`)
                              ) && (
                                <p
                                  style={{
                                    color: "#ff4d4f",
                                    fontSize: "10px",
                                  }}
                                >
                                  Value must be greater than Interest From Value
                                </p>
                              )}
                          </div>
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="rate_card_input_info">
                  <p>Admin Fee</p>
                  <div className="rate_card_input_block">
                    <Controller
                      control={control}
                      name={`products.[${index}].admin_fee_from`}
                      rules={{
                        required: !isChecked[GetName(item.name)],
                      }}
                      render={({ field }) => {
                        return (
                          <div className="input-group">
                            <label>From</label>
                            <InputNumber
                              type="number"
                              min={0}
                              disabled={watch(`products.[${index}].active`) == 0}

                              prefix="$"
                              name={field.name}
                              ref={field.ref}
                              value={field.value}
                              status={
                                isChecked[GetName(item.name)]
                                  ? null
                                  : errors?.products?.[index]?.admin_fee_from
                                    ? "error"
                                    : null
                              }
                              prefixCls="sign_Icon"
                              placeholder="0.00"
                              precision={2}
                              step="0.01"
                              className="!w-full cusAdmInputNumber2"
                              onChange={(val) => field.onChange(val)}
                            />
                          </div>
                        );
                      }}
                    />
                    {console.log("isChecked", isChecked)}
                    <Controller
                      control={control}
                      name={`products.[${index}].admin_fee_to`}
                      rules={{
                        required: !isChecked[GetName(item.name)],
                      }}
                      render={({ field }) => {
                        return (
                          <div className="input-group">
                            <label>To</label>
                            <InputNumber
                              type="number"
                              min={0}
                              disabled={watch(`products.[${index}].active`) == 0}

                              prefix="$"
                              name={field.name}
                              ref={field.ref}
                              value={field.value}
                              status={
                                isChecked[GetName(item.name)]
                                  ? null
                                  : errors?.products?.[index]?.admin_fee_to
                                    ? "error"
                                    : Number(
                                      getValues(
                                        `products.[${index}].admin_fee_from`
                                      )
                                    ) > field.value
                                      ? "error"
                                      : null
                              }
                              prefixCls="sign_Icon"
                              placeholder="0.00"
                              precision={2}
                              step="0.01"
                              className="!w-full cusAdmInputNumber2"
                              onChange={(val) => field.onChange(val)}
                            />

                            {watch(`products.[${index}].admin_fee_to`) !== "" &&
                              Number(
                                watch(`products.[${index}].admin_fee_from`)
                              ) >
                              Number(
                                watch(`products.[${index}].admin_fee_to`)
                              ) && (
                                <p
                                  style={{
                                    color: "#ff4d4f",
                                    fontSize: "10px",
                                  }}
                                >
                                  Value must be greater than Admin-Fee From
                                  Value
                                </p>
                              )}
                          </div>
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* {isModalOpen.type === "edit" && (
                <div className="rate_card_input_info">
                  <p>Set a scheduled date for the changes</p>
                  <Controller
                    control={control}
                    name={`products.[${index}].scheduled_date_time`}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => {
                      return (
                        <div className="input-group">
                          <label>Date & Time</label>
                          <DatePicker
                            showTime
                            placeholder="DD-MM-YYYY HH:MM"
                            format="DD-MM-YYYY HH:mm"
                            name={field.name}
                            ref={field.ref}
                            className={`py-[8px] max-w-[190px]`}
                            value={
                              scheduleDates[GetName(item.name)] !== null
                                ? dayjs(scheduleDates[GetName(item.name)])
                                : field.value
                                  ? dayjs(field.value).minute(0)
                                  : null
                            }
                            onChange={(date) => {
                              console.log("DATE PICKER", date)
                              field.onChange(date !== null ? date.valueOf() : null);
                              setScheduleDates({
                                ...scheduleDates,
                                [GetName(item.name)]: date !== null ? date.valueOf() : null,
                              });
                            }}
                            onOk={(date) => {
                              field.onChange(date ? date.valueOf() : null);
                              setScheduleDates({
                                ...scheduleDates,
                                [GetName(item.name)]: date !== null ? date.valueOf() : null,
                              });
                            }}
                            minuteStep={60}
                          />
                        </div>
                      );
                    }}
                  />
                </div>
              )} */}
            </div>
          </section>
        ))}

        <div className="text-right">
          <Button type="primary" htmlType="submit" className="sav_btn">
            {isModalOpen?.type === "edit" ? "Update Rates" : "Save Rates"}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
export default FloorRatesModal;
